module.exports = __webpack_public_path__ + "static/media/bedroom_thumb.31ae7bc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bedroom_thumb.jpg
// module id = 234
// module chunks = 0